import { useContext, useEffect, useState } from "react";

import { Grid, Tooltip } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";

import { BallContainer } from "./styles";
import TableDefault from "../../../../components/grid/TableDefault";
import MaskService from "../../../../utils/mask/maskService";
import SpeedDialErp from "../../../../components/speeddial/SpeedDialErp";
import { Check, Clear } from "@material-ui/icons";

import RedBall from "../../../../assets/imgs/bolinha-vermelha.png";
import GreenBall from "../../../../assets/imgs/bolinha-verde.png";
import Btn from "../../../../components/buttons/Btn";
import CompanyModalRuralEstablishment from "./children/CompanyModalRuralEstablishment";
import TextFieldErp from "../../../../components/basics/TextFieldErp";
import Loading from "../../../../components/basics/Loading";
import {
  CompanyRuralEstablishmentsContext,
  CompanyRuralEstablishmentsContextProvider,
} from "./contexts/CompanyRuralEstablishmentsContext";
import useCompanyRuralEstablishmentsController from "./controllers/CompanyRuralEstablishmentsController";

const View = () => {
  const {
    mainLoading,
    ruralEstablishment,
    rowsTotal,
    textFilter,
    setTextFilter,
  } = useContext(CompanyRuralEstablishmentsContext);

  const {
    handleGetRuralEstablishments,
    customHandleChangePage,
    handleSearchRuralEstablishments,
  } = useCompanyRuralEstablishmentsController();

  const [open, setOpen] = useState(false);
  const [rowEdit, setRowEdit] = useState(null);
  const [dataTable, setDataTable] = useState([]);
  const [pagePropDefault, setPagePropDefault] = useState(0);
  const [perPage] = useState(10);

  const columns = [
    {
      id: "acoes",
      label: "Ações",
      align: "center",
      format: (item) => {
        let itemActions = [
          {
            name: "Editar",
            icon: <EditOutlinedIcon />,
            action: () => {
              setRowEdit(item);
              setOpen(true);
            },
          },
        ];

        return <SpeedDialErp actions={itemActions} />;
      },
    },
    {
      id: "description",
      label: "Descrição",
    },
    {
      id: "stateInscription",
      label: "Inscrição Estadual",
    },
    {
      id: "cep",
      label: "CEP",
      align: "center",
      format: (item) => MaskService.toMask("cep", item.address?.zipCode || ""),
    },
    {
      id: "endereco",
      label: "Endereço",
      format: (item) =>
        `${item.address?.publicPlace || "-"}, ${item.address?.number || "-"}`,
    },
    {
      id: "complemento",
      label: "Complemento",
      format: (item) => item.address?.additionalData || "-",
    },
    {
      id: "bairro",
      label: "Bairro",
      format: (item) => item?.address?.district || "-",
    },
    {
      id: "municipio_uf",
      label: "Município-UF",
      format: (item) => {
        const stateAcronym = item?.address?.state?.acronym || null;

        const countyDescription = item?.address?.city?.description || null;

        return `${countyDescription || ""} - ${stateAcronym || ""}`;
      },
    },
    {
      id: "pais",
      label: "País",
      format: (item) => item.address?.country?.description || "-",
    },
    {
      id: "contato",
      label: "Contato",
      format: (item) =>
        Array.isArray(item?.contacts) && item.contacts[0]?.name
          ? item.contacts[0]?.name
          : "-",
    },
    {
      id: "telefone",
      label: "Telefone",
      format: (item) =>
        Array.isArray(item?.contacts) && item.contacts[0]?.phone
          ? MaskService.toMask("cel-phone", item.contacts[0]?.phone || "")
          : "-",
    },
    {
      id: "principal",
      label: "Principal",
      format: (item) =>
        item.mainEstablishment ? (
          <Check style={{ color: "green" }} />
        ) : (
          <Clear style={{ color: "red" }} />
        ),
    },
    {
      id: "ativo",
      label: "Ativo",
      format: (item) =>
        item.active ? (
          <BallContainer>
            <img src={GreenBall} alt="Ativo" />
          </BallContainer>
        ) : (
          <BallContainer>
            <img src={RedBall} alt="Inativo" />
          </BallContainer>
        ),
    },
  ];

  useEffect(() => {
    handleGetRuralEstablishments({});
  }, [handleGetRuralEstablishments]);

  useEffect(() => {
    (async () => {
      const newList = [];
      ruralEstablishment.forEach(
        (item, index) =>
          (newList[index] = {
            ...item,
            index: index,
          })
      );

      setDataTable(newList);
    })();
  }, [ruralEstablishment]);

  useEffect(() => {
    setPagePropDefault(0);
  }, [textFilter]);

  return (
    <>
      <Loading open={mainLoading} />

      {open && (
        <CompanyModalRuralEstablishment
          open={open}
          setOpen={setOpen}
          setRowEdit={setRowEdit}
          rowEdit={rowEdit}
        />
      )}
      <Grid
        container
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
      >
        <Grid item xs={5}>
          <TextFieldErp
            value={textFilter}
            setValue={setTextFilter}
            label="Busque por Descrição, IE, CEP, Endereço ou Telefone"
            variant="filled"
            onChange={({ target: { value } }) => {
              handleSearchRuralEstablishments(value);
            }}
          />
        </Grid>
        <Grid
          item
          xs={3}
          container
          alignItems="center"
          justifyContent="flex-end"
        >
          <Tooltip title="Adicionar Estabelecimento">
            <Grid item flex={1}>
              <Btn
                label="Novo"
                startIcon={<AddIcon />}
                onClick={(event) => {
                  event.stopPropagation();
                  setOpen(true);
                }}
              />
            </Grid>
          </Tooltip>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TableDefault
            columns={columns}
            values={dataTable}
            maxHeight="510px"
            minHeight="510px"
            smallFont
            quantidadeItensTotal={rowsTotal}
            rowsPerPage={perPage}
            customHandleChangePage={customHandleChangePage}
            pageProp={pagePropDefault}
            setPageProp={setPagePropDefault}
          />
        </Grid>
      </Grid>
    </>
  );
};

const CompanyRuralEstablishments = ({ ...props }) => {
  return (
    <CompanyRuralEstablishmentsContextProvider>
      <View {...props} />
    </CompanyRuralEstablishmentsContextProvider>
  );
};

export default CompanyRuralEstablishments;
